.mobilePicker {
    width: min(100%, 420px);
}

.mobilePicker :global(.MuiPickersLayout-root),
.mobilePicker :global(.MuiPickersLayout-contentWrapper),
.mobilePicker :global(.MuiMultiSectionDigitalClock-root) {
    width: 100%;
}

.mobilePicker :global(.MuiMultiSectionDigitalClockSection-root) {
    width: auto;
    flex: 1 1 0;
}

.mobilePicker :global(.MuiMultiSectionDigitalClockSection-item) {
    width: auto;
}
